import type { TrackingPersona } from './trackingUtils';

interface TrackingPersonaConfig {
    persona: TrackingPersona;
    canCreateOccurrence: boolean;
    readOnly: boolean;
}

const trackingPersonaConfig: Record<TrackingPersona, TrackingPersonaConfig> = {
    TOWER: { persona: 'TOWER', canCreateOccurrence: true, readOnly: false },
    CONSULTANT: { persona: 'CONSULTANT', canCreateOccurrence: true, readOnly: false },
    MANAGER: { persona: 'MANAGER', canCreateOccurrence: false, readOnly: true },
    PARTNERSHIP: { persona: 'PARTNERSHIP', canCreateOccurrence: false, readOnly: false },
};

export const getTrackingPersonaConfig = (persona: TrackingPersona): TrackingPersonaConfig =>
    trackingPersonaConfig[persona];
